"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var HeadlineSlotLocalTheme = function HeadlineSlotLocalTheme(theme) {
  return {
    appearance: {
      primary: {
        backgroundColor: "linear-gradient(".concat(theme.color.gradient1["default"], ")"),
        inverseText: true
      },
      secondary: {
        backgroundColor: theme.color.secondary1["default"],
        inverseText: true
      },
      alt1: {
        backgroundColor: "linear-gradient(".concat(theme.color.gradient3["default"], ")"),
        inverseText: false,
        iconAppearance: 'secondary'
      },
      alt2: {
        backgroundColor: theme.color.monochrome6["default"],
        inverseText: true
      }
    },
    size: {
      1: {
        headingSize: 2,
        textSize: 1
      },
      2: {
        headingSize: 3,
        textSize: 2
      }
    }
  };
};
var _default = HeadlineSlotLocalTheme;
exports["default"] = _default;
//# sourceMappingURL=HeadlineSlot.theme.js.map